import React, {Fragment, FunctionComponent, StrictMode} from 'react'
import {Checkbox} from "@App/Components/common/Checkbox";
import {actionCreators, State} from '@App/state'
import {useDispatch, useSelector} from "react-redux";
import {bindActionCreators} from "@reduxjs/toolkit";
import {changeOnlyManufacturerFilter} from "@App/state/action-creators";



export const ManufacturerFilter: FunctionComponent = () => {

    const onlyManufacturer = useSelector((state: State) => state.filters.onlyManufacturer)

    const dispatch = useDispatch();
    const {
        changeOnlyManufacturerFilter,
    } = bindActionCreators(actionCreators, dispatch)

    return (
        <StrictMode>
            <Fragment key={'fragment-bookable'}>
                <Checkbox status={onlyManufacturer}
                          title={'Nur Hersteller-Vertragswerkstätten'}
                          onChange={() => changeOnlyManufacturerFilter(!onlyManufacturer)}/>
            </Fragment>
        </StrictMode>
    )
}
